import { render, staticRenderFns } from "./Consierge.vue?vue&type=template&id=848082b6"
import script from "./Consierge.vue?vue&type=script&lang=js"
export * from "./Consierge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports